import { LOCALE_CHANGED } from '../../constants'
import { actionLoggerLog } from '../../actions'
import getAttributesImport from '../../store/attributes'
import { selectors as backendSelectors } from '../Backend'
import { actions as usersActions, selectors as usersSelectors } from '../Users'

export { launcherOpenUrl } from '../../launcherBackend/launcher-command'

export { default as Button } from '../../components/Button'
export { default as getTexts } from '../../store/localizer'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return {
        slingerRefresh: attributes.service.slinger.refresh,
        getEula: attributes.service.slinger.getEula,
        clientTokenUrl: attributes.service.sso.clientToken,
    }
}

export const constants = {
    LOCALE_CHANGED,
}

export const actions = {
    log: actionLoggerLog,
    setTokens: (serverId, userId, access, refresh) =>
        usersActions.setUserTokens(serverId, userId, { access, refresh }),
}

export const selectors = {
    getLocale: state => backendSelectors.getLocale(state),
    getActiveServer: state => backendSelectors.getActiveServer(state),
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    getAccessToken: (state, serverId, userId) =>
        usersSelectors.getUserAccessToken(state, serverId, userId),
    getRefreshToken: (state, serverId, userId) =>
        usersSelectors.getUserRefreshToken(state, serverId, userId),
}



// WEBPACK FOOTER //
// ./src/features/Eula/imports.js